<div class="error-container">
  <div class="error-content">
    <p-card class="error-card w-full max-w-[600px]">
      <div class="error-icon-wrapper">
        <div class="error-icon">
          <i class="fa-duotone fa-solid fa-triangle-exclamation text-(--warning-500)"></i>
        </div>
      </div>

      <div class="error-header">
        <h1 i18n>Login Unsuccessful</h1>
      </div>

      <div class="error-message">
        <p i18n class="error-action">
          Please try again. If you need assistance, please contact PULSE™ Support at
          <a [href]="supportEmailHref" class="hyperlink whitespace-nowrap">{{ supportEmail }}</a>.
        </p>
      </div>

      <div class="error-actions">
        <p-button i18n-label label="Log In" styleClass="w-full p-button-lg" (click)="onLoginClick()">
          <i class="fa-duotone fa-solid fa-arrow-right-to-bracket mr-2"></i>
        </p-button>
      </div>
    </p-card>
  </div>
</div>
